/**
 * Legal document version constants — per brand (ADR-088). Bump ONLY on
 * substantive changes (new processor, retention change, rights change, a
 * brand's document content changing, ...). Typo fixes do NOT require a
 * version bump. Version bump must be in the same commit as the `.md` content
 * change. See ADR-075 for the versioning mechanism, ADR-088 for the
 * per-brand dimension.
 *
 * Version labels carry a brand suffix (`-kn` / `-hb`) so that losing the
 * `brandSlug` on the content-serving path produces a loud, detectable
 * `LEGAL_VERSION_MISMATCH` instead of a silent cross-brand content leak
 * (ADR-088 D2).
 */
import { BrandSlug } from './brand';

export const LEGAL_VERSIONS_BY_BRAND: Record<
  BrandSlug,
  { TERMS: string; PRIVACY: string }
> = {
  kiedynabory: {
    TERMS: '2026-07-09-kn',
    PRIVACY: '2026-11-03-kn',
  },
  hotelb2b: {
    TERMS: '2026-07-06-hb',
    PRIVACY: '2026-11-03-hb',
  },
};

/**
 * @deprecated Pre-ADR-088 single-brand shape. Equals
 * `LEGAL_VERSIONS_BY_BRAND.kiedynabory` — kept so call sites not yet
 * migrated to the per-brand registry keep compiling. New code should go
 * through `getLegalContent(brandSlug)` instead.
 */
export const LEGAL_VERSIONS = LEGAL_VERSIONS_BY_BRAND.kiedynabory;

export type LegalVersion = (typeof LEGAL_VERSIONS)[keyof typeof LEGAL_VERSIONS];
